module.exports = "/_next/static/images/aceb50286fafdefe7db0240e75d47f49-rewards-partners@0.75x.jpg";